module.exports = __webpack_public_path__ + "img/deepwater-inner-corner.ebf78b21.png";